import { useMemo } from 'react';
import { useListAllRecordsQuery, useListRecordsQuery } from '@platform/state/api';
import type { IApiErrorPlain, IRecordListParams, IRecordPage } from '@platform/core/types';
import type { IListPageResult } from './IListPageResult';
import { exportParamsOf } from './listQuery';
import { isPagedView } from './viewKinds';

/**
 * Дані подання списку (UIUX tables/pagination): таблиця, картки й редагування в рядку — сторінка запиту `query`; етапи, беклог, розділений
 * і календар — увесь відфільтрований список (той самий запит без сторінки, до 1000 записів) однією «сторінкою». `skip` — без запиту.
 */
export function useListPage(ws: string, rt: string, query: IRecordListParams, view: string, skip: boolean): IListPageResult {
  const paged = isPagedView(view);
  const all = useMemo(() => exportParamsOf(query), [query]);
  const one = useListRecordsQuery({ ws, rt, params: query }, { skip: skip || !paged });
  const every = useListAllRecordsQuery({ ws, rt, params: all }, { skip: skip || paged });
  const batch = every.data;
  const whole = useMemo((): IRecordPage | undefined => (batch ? { items: batch.items, total: batch.total, page: 1, pageSize: batch.items.length } : undefined), [batch]);
  const src = paged ? one : every;
  return { page: skip ? undefined : paged ? one.data : whole, isFetching: !skip && src.isFetching, error: skip ? undefined : (src.error as IApiErrorPlain | undefined), refetch: src.refetch };
}
